import * as React from 'react';
import { connect } from 'react-redux';
import { setTiposPublicacion, fetchTiposPublicacion } from '../../../actions/tiposPublicacionActions';
import { withNavigation } from '../../General/withNavigation';
import MiniSpinner from '../../General/MiniSpinner';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../../helper/sellerMergedSelector';
import { formatoDecimal } from '../../../utilities/formatoNumeros';

class TiposParaGuardar extends React.Component {
    constructor() {
        super();
        this.state = {
            listaIdTiposPublicaciones: []
        }
    };

    componentDidMount() {
        const id = this.props.seller?.codigo;
        const idNum = parseInt(id, 10);
        if (!id || !Number.isFinite(idNum) || idNum <= 0) {
            return;
        }
        if (!this.props.loadedSellerTabTipo && (!Array.isArray(this.props.settedTiposPublicacion) || this.props.settedTiposPublicacion.length === 0)) {
            this.props.fetchTiposPublicacion(idNum);
        }
    }

    borrarFila = (codigo) => {
        const setted = this.props.settedTiposPublicacion;
        const asignados = this.props.tiposPublicacionesAsignados;
        const jsonSetted = JSON.stringify(setted);
        if (jsonSetted !== "[]" && jsonSetted !== "{}") {
            const next = Array.isArray(setted) ? [...setted] : [];
            const index = next.findIndex(
                (x) => x.codigo == codigo || x.idTipoPublicacion == codigo || x.IdTipoPublicacion == codigo
            );
            if (index !== -1) {
                next.splice(index, 1);
                this.props.setTiposPublicacion(next);
            }
        } else {
            const next = Array.isArray(asignados) ? [...asignados] : [];
            const index = next.findIndex(
                (x) => x.codigo == codigo || x.idTipoPublicacion == codigo || x.IdTipoPublicacion == codigo
            );
            if (index !== -1) {
                next.splice(index, 1);
                this.props.setTiposPublicacion(next);
            }
        }
    }

    /** Misma fuente de datos que el alta de tipos: store tiposPublicacion, con respaldo en publicaciones. */
    listaTiposParaMostrar = () => {
        if (this.props.location?.pathname === "/Sellers/Nuevo") {
            return [];
        }
        const setted = this.props.settedTiposPublicacion;
        const assigned = this.props.tiposPublicacionesAsignados;
        const raw =
            Array.isArray(setted) && setted.length > 0
                ? setted
                : Array.isArray(assigned) && assigned.length > 0
                    ? assigned
                    : [];
        return raw.filter((item) => {
            if (!item || typeof item !== "object" || Object.keys(item).length === 0) {
                return false;
            }

            const estado = item?.estado ?? item?.Estado;
            return estado !== 2;
        });
    }

    codigoTipo = (item) =>
        item?.codigo ?? item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? "";

    render() {
        const lista = this.listaTiposParaMostrar();
        const puedeQuitar = this.props.tipoUsuario === 2;
        const isEditRoute = this.props.location?.pathname?.startsWith('/Sellers/Editar');
        const showLoadingTipos = isEditRoute && this.props.loadingTiposPublicacion;

        return (
            <div className="w-100">
                <header className="profile-section__head">
                    <span className="profile-section__icon" aria-hidden="true"><i className="mdi mdi-format-list-bulleted" /></span>
                    <div>
                        <h5 className="profile-section__title">Tipo de publicación</h5>
                        <p className="profile-section__hint">Tipos asociados al seller.</p>
                    </div>
                </header>

                <div className="admin-list-stack">
                    {showLoadingTipos ? (
                        <div className="d-flex align-items-center gap-2 text-body-secondary small mb-0">
                            <MiniSpinner />
                            <span>Cargando tipos de publicacion...</span>
                        </div>
                    ) : lista.length === 0 ? (
                        <p className="text-body-secondary small mb-0">No hay tipos de publicación asignados.</p>
                    ) : (
                        lista.map((item, i) => {
                            const idTipo = this.codigoTipo(item);
                            return (
                                <div key={`${idTipo}-${i}`} className="admin-list-card p-3 admin-list-card--vigente">
                                    <div className="row g-2 g-md-3 align-items-center justify-content-between">
                                        <div className="col-auto">
                                            <span className="admin-id-badge">{idTipo}</span>
                                        </div>
                                        <div className="col-12 col-md-5 col-lg-6 text-break">
                                            <div className="admin-list-card__title fw-semibold small mb-0">
                                                {item.descripcion}
                                            </div>
                                        </div>
                                        <div className="col-auto ms-md-auto d-flex align-items-center gap-2">
                                            <span className="admin-metric-pill">
                                                {formatoDecimal(item.comision)}
                                                <i className="fas fa-percent" aria-hidden="true" />
                                            </span>
                                            {puedeQuitar && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link btn-sm text-danger p-0"
                                                    onClick={() => this.borrarFila(item.codigo ?? idTipo)}
                                                    title="Quitar"
                                                >
                                                    <i className="fas fa-trash-alt" />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        );
    }
}
TiposParaGuardar.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    // Redux props
    settedTiposPublicacion: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    loadedSellerTabTipo: PropTypes.bool,
    seller: PropTypes.shape({
        codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    tiposPublicacionesAsignados: PropTypes.array,
    tipoUsuario: PropTypes.number,
    loadingTiposPublicacion: PropTypes.bool,
    // Actions props
    fetchTiposPublicacion: PropTypes.func,
    setTiposPublicacion: PropTypes.func,
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    tiposPublicacionesAsignados: state.publicaciones.tiposPublicacion,
    loadedSellerTabTipo: state.tiposPublicacion.loadedSellerTabTipo,
    loadingTiposPublicacion: state.tiposPublicacion.loadingTiposPublicacion,
    editando: state.general.editando,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion
});

export default withNavigation(connect(mapStateToProps, {
    fetchTiposPublicacion,
    setTiposPublicacion
})(TiposParaGuardar));

